import { memo, useMemo } from "react";
import { normalizeDate } from "./helpers";
import RepostIcon from "./images/icons/repost.svg?react";
import "./RepostInfo.scss";

interface IRepostInfo {
  createDate: number;
  userName: string;
}

export const RepostInfo: React.FC<IRepostInfo> = memo(({
  createDate,
  userName
}) => {
  const { publishDate, publishTime } = useMemo(() => normalizeDate(createDate), [createDate]);

  return (
    <div className="RepostInfo">
      <span className="RepostInfo-Icon"><RepostIcon /></span>
      {userName} • {publishDate} @{publishTime}
    </div>
  );
});
